import { Button, Typography, IconButton, Theme} from '@material-ui/core';
import { RemoveCircleOutlineOutlined } from '@material-ui/icons';
import { makeStyles, createStyles } from '@material-ui/styles';
import React, { useContext, FC } from 'react';
import { FormContext } from '../FormContext';
import { registry } from '../registry';
import { FormControlProps, useDataFieldValidity, useEditability, useDataValue } from '../utils';

import { TallyDefinition } from '../services/layout';

var useStyles = makeStyles(function(theme: Theme) {
  return createStyles( {
    root: {
      flex: 1, display: 'flex', flexDirection: 'column'
    },
    incrButton: {
      display: 'flex', height: '52px', textTransform: 'none', touchAction: 'manipulation'
    },
    incrText: {
      fontWeight: 'bolder'
    },
    summaryRow: {
      flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    decrText: {
      color: theme.palette.text.primary
    },
    summaryItem: {
      flex: 1
    },
    count: {
      flex: 1, textAlign: 'center'
    },
    error: {
      color: theme.palette.error.main, marginTop: theme.spacing(-3), marginLeft: theme.spacing(3)
    }
  })
});

// fix typings
export const Tally: FC<FormControlProps<TallyDefinition>> = function(props) {
    const classes = useStyles({});
    const definition = props.definition;
    const { scope, onSetData } = useContext(FormContext);

    // put these in useEffect? or useMemo?
    const error = useDataFieldValidity(definition.dataPath);
    const editable = useEditability(definition.editable);
    const count: number | undefined = useDataValue(definition.dataPath);
    const handleIncrement = function(incrementValue: number) {
      const newValue = (count || 0) + incrementValue;
      onSetData(definition.dataPath, scope, newValue);
    };

    return (
      <div className = { classes.root }>
        <Button
          className = { classes.incrButton }
          color = { 'secondary' }
          onClick = { () => handleIncrement(1) }
          variant = { 'outlined' }
          disabled = { !editable }>
          <Typography variant = { 'h6' } className = { classes.incrText }>
            { definition.label }
          </Typography>
        </Button>
        <div className = { classes.summaryRow }>
          <div className = { classes.summaryItem }>
            <IconButton
              color = { 'default' }
              disabled = { count === 0 }
              onClick = { () => handleIncrement(-1) }>
                <RemoveCircleOutlineOutlined></RemoveCircleOutlineOutlined>
            </IconButton>
            <Typography variant = { 'body1' } className = { classes.count }>
              { count }
            </Typography>
            <div className = { classes.summaryItem }>
              { error &&
                <Typography className = { classes.error } variant = { 'caption' }>
                  { error }
                </Typography>
              }
            </div>
          </div>
        </div>
      </div>
    )
};

registry.registerComponent('Tally', Tally);
